import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { timeout } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class ReleaseService {
  constructor(protected http: HttpClient) {}

  contentCheck(params: HttpParams) {
    const url = `${environment.url.api}/release/content-check`
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

}